//@flow
import * as React from 'react';
import { Box, Columns, Text, Position } from '@locus-taxy/neo-ui';
import { type TFunction } from 'react-i18next';
import { neoUIColors } from 'common/enums/ColorEnum';
import { FpContainers } from 'common/entity/pjpMaster/planView/FpPlanDetailsContainer';

type FpActionsBarPopupProps = {
    changeVisitsView: (view: string) => void,
    selectedOption: (view: string) => void,
    selectedOption: string,
    t: TFunction
};
export default class FpActionsBarPopup extends React.PureComponent<FpActionsBarPopupProps> {
    changeVisibleSection: () => void = () => {
        const { changeVisitsView, selectedOption } = this.props;
        if (selectedOption === FpContainers.Allocated) {
            changeVisitsView(FpContainers.Unallocated);
        } else if (selectedOption === FpContainers.Unallocated) {
            changeVisitsView(FpContainers.Allocated);
        }
    };

    render() {
        const { selectedOption, t } = this.props;
        return (
            <Position
                position="absolute"
                zIndex={30}
                top="224px"
                width="163px"
                left="60px"
                sx={{
                    borderColor: neoUIColors.grey200.code,
                    boxShadow: `0 0.2rem 0.6rem 0.2rem ${neoUIColors.grey200.code}`,
                    border: `1px solid ${neoUIColors.grey200.code}`,
                    cursor: 'pointer'
                }}
            >
                <Box
                    p={4}
                    backgroundColor="white"
                    onClick={this.changeVisibleSection}
                >
                    <Columns align="center" alignY="center">
                        <Text fontSize={2} fontWeight="400">
                            {selectedOption === FpContainers.Allocated
                                ? t('fpPlanView.unallocated')
                                : t('fpPlanView.allocated')}
                        </Text>
                    </Columns>
                </Box>
            </Position>
        );
    }
}
